import ChevronRightIcon from "@assets/icons/cheveron-right.svg?react";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import useIsSmallScreen from "@src/app/hooks/useIsSmallScreen";
import clsx from "clsx";

type ScrollIndicatorProps = {
  containerRef: React.RefObject<HTMLDivElement>;
  theme?: ThemeEnum;
};

export default function ScrollIndicator({
  containerRef,
  theme = ThemeEnum.light,
}: ScrollIndicatorProps) {
  const isSmallScreen = useIsSmallScreen();
  const isDefault = theme === ThemeEnum.light;

  const handleScroll = () => {
    const el = containerRef.current;
    if (!el) return;

    const maxScrollLeft = el.scrollWidth - el.clientWidth;
    const nextScrollLeft = el.scrollLeft + 100;

    el.scrollTo({
      left: Math.min(nextScrollLeft, maxScrollLeft),
      behavior: "smooth",
    });
  };

  return (
    <div
      data-testid="scroll-indicator"
      className="relative flex shrink-0 items-center justify-end"
    >
      {isSmallScreen && (
        <div
          className="pointer-events-none absolute top-0 -left-7 z-10 h-9 w-7"
          style={{
            background: isDefault
              ? "linear-gradient(to right, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 0.8) 80%, rgba(250, 250, 250, 1) 100%)"
              : "linear-gradient(to right, rgba(57, 57, 57, 0) 0%, rgba(57, 57, 57, 0.8) 80%, rgba(57, 57, 57, 1) 100%)",
          }}
        />
      )}
      <button
        onClick={handleScroll}
        className="hover:bg-button-ghost-hover relative flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-[100px] transition-colors"
        aria-label="Scroll right"
      >
        <ChevronRightIcon
          className={clsx(
            "size-6",
            isDefault ? "text-primary" : "text-primary-on-dark",
          )}
        />
      </button>
    </div>
  );
}
